(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.announcementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;
      this.logoFadeTicking = false;
      this.logoFadeProgress = null;
      this.logoFadeTargetProgress = 0;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
      this.updateLogoFaviconFade(window.pageYOffset || document.documentElement.scrollTop);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.announcementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.headerIsAlwaysSticky) {
        this.header.classList.toggle('scrolled-past-header', scrollTop > this.headerBounds.bottom);
        this.currentScrollTop = scrollTop;
        this.updateLogoFaviconFade(scrollTop);
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
      this.updateLogoFaviconFade(scrollTop);
    }

    updateLogoFaviconFade(scrollTop) {
      let progress = 0;

      if (this.announcementBarHeight > 0) {
        const fadeDistance = this.announcementBarHeight * 0.25;
        const fadeStart = this.announcementBarHeight - fadeDistance;
        progress = Math.max(0, Math.min(1, (scrollTop - fadeStart) / fadeDistance));
      } else if (scrollTop > 0) {
        progress = 1;
      }

      this.logoFadeTargetProgress = progress;

      if (this.logoFadeTicking || progress === this.logoFadeProgress) return;

      this.logoFadeTicking = true;
      requestAnimationFrame(() => {
        const nextProgress = this.logoFadeTargetProgress;

        if (nextProgress === this.logoFadeProgress) {
          this.logoFadeTicking = false;
          return;
        }

        const logo = this.header.querySelector('.header__heading-logo-wrapper');
        const favicon = this.header.querySelector('.header__favicon');

        if (logo) logo.style.opacity = 1 - nextProgress;
        if (favicon) favicon.style.opacity = nextProgress;

        this.logoFadeProgress = nextProgress;
        this.logoFadeTicking = false;
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-campaign')) {
    class ProductCampaign extends HTMLElement {
      connectedCallback() {
        this.action = this.querySelector('[data-campaign-action]');
        this.status = this.querySelector('[data-campaign-status]');
        this.discountCode = this.dataset.discountCode || '';
        this.discountCodeLower = this.discountCode.toLowerCase();
        this.isApplying = false;
        this.handleApply = this.handleApply.bind(this);
        this.action?.addEventListener('click', this.handleApply);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshState());
        }

        this.refreshState();
      }

      disconnectedCallback() {
        this.action?.removeEventListener('click', this.handleApply);
        this.cartUpdateUnsubscriber?.();
      }

      setState(label, disabled = false) {
        if (this.status) this.status.textContent = label;
        if (this.action) this.action.disabled = disabled;
      }

      isDiscountApplied(cart) {
        const titles = [];

        (cart?.cart_level_discount_applications || []).forEach((discount) => {
          const title = discount?.title || discount?.discount_application?.title;
          if (title) titles.push(title);
        });

        (cart?.items || []).forEach((item) => {
          (item?.discounts || []).forEach((discount) => {
            if (discount?.title) titles.push(discount.title);
          });
          (item?.line_level_discount_allocations || []).forEach((allocation) => {
            const title = allocation?.discount_application?.title;
            if (title) titles.push(title);
          });
        });

        return titles.some((title) => String(title).toLowerCase() === this.discountCodeLower);
      }

      async getCart() {
        const response = await fetch(`${routes.cart_url}.js`, {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('Unable to load cart');
        return response.json();
      }

      async refreshState() {
        if (this.isApplying || !this.discountCode) return;

        try {
          const cart = await this.getCart();
          if (this.isDiscountApplied(cart)) {
            this.setState(this.dataset.appliedLabel, true);
          } else {
            this.setState(this.dataset.applyLabel, false);
          }
        } catch (error) {
          this.setState(this.dataset.applyLabel, false);
        }
      }

      async handleApply() {
        if (this.isApplying || !this.discountCode) return;

        this.isApplying = true;
        this.setState(this.dataset.applyingLabel, true);

        try {
          const response = await fetch(`${routes.cart_update_url}.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ discount: this.discountCode }),
          });
          if (!response.ok) throw new Error('Unable to apply discount');

          const cart = await response.json();

          if (this.isDiscountApplied(cart)) {
            this.setState(this.dataset.appliedLabel, true);
          } else {
            this.setState(this.dataset.fallbackLabel, true);
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            await publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-campaign',
              cartData: cart,
            });
          }
        } catch (error) {
          this.setState(this.dataset.applyLabel, false);
        } finally {
          this.isApplying = false;
        }
      }
    }

    customElements.define('product-campaign', ProductCampaign);
  }

  if (!customElements.get('envelope-name-input')) {
    class EnvelopeNameInput extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info') || document.querySelector('product-info');
        this.cardsContainer = this.querySelector('[data-personalisation-cards]');
        this.addCardButton = this.querySelector('[data-add-personalisation-card]');
        this.cardLabel = this.dataset.cardLabel || 'Envelope';
        this.removeCardLabel = this.dataset.removeCardLabel || 'Remove envelope';
        this.quantityCardCache = new Map();
        this.syncingQuantity = false;
        this.syncingBulk = false;

        this.handleAddCard = this.handleAddCard.bind(this);
        this.handleSwatchClick = this.handleSwatchClick.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);

        this.addCardButton?.addEventListener('click', this.handleAddCard);
        this.addEventListener('click', this.handleSwatchClick);
        this.addEventListener('change', this.handleCheckboxChange);
        this.productInfo?.addEventListener('change', this.handleOptionChange);

        this.handleQuantityEvent = (event) => {
          const target = event?.target;
          if (target && (target.classList?.contains('quantity__input') || (target.matches && target.matches('.quantity__input')) || target.name === 'quantity')) {
            this.handleQuantityChange();
          }
        };
        (this.productInfo || document).addEventListener('change', this.handleQuantityEvent);
        this.handleNameInput = (event) => {
          const input = event.target?.closest?.('[data-personalisation-input]');
          if (!input) return;

          const card = input.closest('[data-personalisation-card]');
          if (!card) return;

          const cardIndex = card.dataset.cardIndex;
          const sameNameControl = this.cards[0]?.querySelector('[data-same-name-for-all]');

          if (cardIndex === '1') {
            if (sameNameControl?.checked) {
              this.cards.slice(1).forEach((additionalCard) => {
                const matchingInput = additionalCard.querySelector('[data-personalisation-field="name"] [data-personalisation-input]');
                if (matchingInput) matchingInput.value = input.value;
              });
            }
          } else {
            if (sameNameControl?.checked) {
              sameNameControl.checked = false;
            }
          }

          this.syncPlaceholders();
        };
        this.addEventListener('input', this.handleNameInput);

        this.syncState();
        this.syncCardsFromSelectedOptions();
        this.syncPlaceholders();
        this.updateDynamicPriceAndTier();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const currentSection = this.getSectionId();
            if (!event?.data?.sectionId || event.data.sectionId === currentSection) {
              this.setQuantity(this.cards.length);
              this.updateDynamicPriceAndTier();
            }
          });

          this.optionChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
            setTimeout(() => {
              this.syncCardsFromSelectedOptions();
              this.setQuantity(this.cards.length);
              this.updateDynamicPriceAndTier();
            }, 60);
          });
        }

        customElements.whenDefined('product-form').then(() => {
          const productForm = this.productInfo?.querySelector('product-form');
          productForm?.editLinePromise?.then((line) => {
            if (!line || !this.isConnected) return;
            this.restoreCartLineEdit(line);
          });
        });
      }

      disconnectedCallback() {
        this.addCardButton?.removeEventListener('click', this.handleAddCard);
        this.removeEventListener('click', this.handleSwatchClick);
        this.removeEventListener('change', this.handleCheckboxChange);
        this.removeEventListener('input', this.handleNameInput);
        this.productInfo?.removeEventListener('change', this.handleOptionChange);
        if (this.handleQuantityEvent) {
          (this.productInfo || document).removeEventListener('change', this.handleQuantityEvent);
          (this.productInfo || document).removeEventListener('input', this.handleQuantityEvent);
        }
        this.variantChangeUnsubscriber?.();
        this.optionChangeUnsubscriber?.();
      }

      get quantityInput() {
        return this.productInfo?.querySelector('.quantity__input') || document.querySelector('.quantity__input');
      }

      get cards() {
        return Array.from(this.cardsContainer?.querySelectorAll('[data-personalisation-card]') || []);
      }

      get maximumQuantity() {
        const maximum = parseInt(this.quantityInput?.max, 10);
        return Number.isNaN(maximum) ? 50 : maximum;
      }

      getSectionId() {
        return this.dataset.sectionId || this.closest('product-info')?.dataset?.section || '';
      }

      getAvailableTiers() {
        const sectionId = this.getSectionId();
        const variantsEl = document.getElementById('envelope-name-variants-' + sectionId) || document.querySelector('[id^="envelope-name-variants-"]');
        let variants = [];
        try {
          variants = variantsEl ? JSON.parse(variantsEl.textContent || '[]') : [];
        } catch (e) {
          variants = [];
        }

        if (!variants || variants.length === 0) {
          return [{ size: 1, price: 195, compareAtPrice: 260, variantId: '' }];
        }

        // Find selected non-bulk option values (e.g. Occasion)
        const selectedNonBulk = [];
        const optionSelects = this.productInfo?.querySelectorAll('select[name^="options["], fieldset input[type="radio"]:checked') || [];
        optionSelects.forEach(opt => {
          const name = (opt.name || '').toLowerCase();
          if (!name.includes('bulk') && !name.includes('discount') && !name.includes('multi-buy') && !name.includes('quantity')) {
            const val = (opt.value || '').trim();
            if (val) selectedNonBulk.push(val);
          }
        });

        // Filter variants matching non-bulk options
        const matchingVariants = variants.filter(v => {
          if (selectedNonBulk.length === 0) return true;
          return selectedNonBulk.every(selectedVal => (v.options || []).includes(selectedVal));
        });

        const listToUse = matchingVariants.length > 0 ? matchingVariants : variants;

        const tiers = [];
        listToUse.forEach(v => {
          let size = 1;
          for (const optVal of (v.options || [])) {
            const match = String(optVal).match(/^(\d+)\s*(envelope|envelopes|piece|pieces|pcs|pack|packs)/i);
            if (match && match[1]) {
              size = parseInt(match[1], 10);
              break;
            }
          }
          tiers.push({
            size: size,
            price: typeof v.price === 'number' ? v.price : Math.round(parseFloat(v.price) * 100),
            compareAtPrice: (v.compare_at_price && v.compare_at_price > v.price)
              ? (typeof v.compare_at_price === 'number' ? v.compare_at_price : Math.round(parseFloat(v.compare_at_price) * 100))
              : (typeof v.price === 'number' ? v.price : Math.round(parseFloat(v.price) * 100)),
            variantId: v.id,
            title: v.title
          });
        });

        tiers.sort((a, b) => b.size - a.size);

        // Deduplicate sizes (keep lowest price if duplicate)
        const uniqueTiers = [];
        const seenSizes = new Set();
        tiers.forEach(t => {
          if (!seenSizes.has(t.size)) {
            seenSizes.add(t.size);
            uniqueTiers.push(t);
          }
        });

        return uniqueTiers.length > 0 ? uniqueTiers : [{ size: 1, price: 195, compareAtPrice: 260, variantId: variants[0]?.id || '' }];
      }

      calculateTiers(count, tiers) {
        let remaining = count;
        const selected = [];
        for (const tier of tiers) {
          while (remaining >= tier.size && tier.size > 0) {
            selected.push(tier);
            remaining -= tier.size;
          }
        }
        if (remaining > 0 && tiers.length > 0) {
          selected.push(tiers[tiers.length - 1]);
        }
        return selected;
      }

      updateDynamicPriceAndTier() {
        const count = Math.max(1, this.cards.length);
        const tiers = this.getAvailableTiers();
        const selectedTiers = this.calculateTiers(count, tiers);

        let totalPriceCents = 0;
        let totalCompareAtCents = 0;
        selectedTiers.forEach(t => {
          totalPriceCents += t.price;
          totalCompareAtCents += t.compareAtPrice;
        });

        const formattedSale = '£' + (totalPriceCents / 100).toFixed(2);
        const formattedCompare = '£' + (totalCompareAtCents / 100).toFixed(2);

        const sectionId = this.getSectionId();

        // Update sale price elements
        const saleEls = document.querySelectorAll(
          '.product .price .price-item--sale, .price__sale .price-item--last, .product .price .price-item--regular, #price-' + sectionId + ' .price-item--regular, #price-' + sectionId + ' .price-item--sale'
        );
        saleEls.forEach(el => {
          el.textContent = formattedSale;
        });

        // Update compare-at price elements
        const comparePriceElements = document.querySelectorAll(
          '.product .price .price__sale s.price-item, .product .price .price__sale s .price-item, #price-' + sectionId + ' .price__sale s.price-item'
        );
        if (totalCompareAtCents > totalPriceCents) {
          comparePriceElements.forEach(el => {
            el.textContent = formattedCompare;
            el.closest('.price')?.classList.add('price--on-sale');
          });

          const discountPercent = Math.round(((totalCompareAtCents - totalPriceCents) / totalCompareAtCents) * 100);
          document.querySelectorAll('[data-discount-badge], .product__discount-badge').forEach(b => {
            b.textContent = discountPercent + '% off';
            b.style.display = '';
          });
        } else {
          comparePriceElements.forEach(el => {
            el.textContent = '';
            el.closest('.price')?.classList.remove('price--on-sale');
          });
        }

        // Sync main product form variant ID
        const form = this.productInfo?.querySelector('product-form form, form[action*="/cart/add"]');
        if (form && selectedTiers[0]?.variantId) {
          let hiddenId = form.querySelector('input[name="id"]');
          if (hiddenId) hiddenId.value = String(selectedTiers[0].variantId);
        }
      }

      syncBulkOption(count) {
        if (this.syncingBulk) return;
        this.syncingBulk = true;

        const selects = this.productInfo?.querySelectorAll('select[name^="options["]') || [];
        selects.forEach(select => {
          const isBulk = Array.from(select.options).some(opt => opt.value.match(/^(\d+)\s*(envelope|envelopes|piece|pieces|pcs|pack|packs)/i));
          if (isBulk) {
            let matchedOpt = Array.from(select.options).find(opt => {
              const m = opt.value.match(/^(\d+)/);
              return m && parseInt(m[1], 10) === count;
            });
            if (matchedOpt && select.value !== matchedOpt.value) {
              select.value = matchedOpt.value;
              const customSelect = select.closest('custom-select');
              if (customSelect && typeof customSelect.syncFromSelect === 'function') {
                customSelect.syncFromSelect();
              }
            }
          }
        });

        const radios = this.productInfo?.querySelectorAll('input[type="radio"]') || [];
        radios.forEach(radio => {
          const m = radio.value.match(/^(\d+)\s*(envelope|envelopes|piece|pieces|pcs|pack|packs)/i);
          if (m && parseInt(m[1], 10) === count) {
            if (!radio.checked) {
              radio.checked = true;
            }
          }
        });

        this.syncingBulk = false;
      }

      setQuantity(quantity) {
        const inputs = this.productInfo?.querySelectorAll('.quantity__input') || document.querySelectorAll('.quantity__input');
        if (!inputs || inputs.length === 0) return;

        this.syncingQuantity = true;
        inputs.forEach(input => {
          input.value = String(quantity);
          input.setAttribute('value', String(quantity));
        });
        this.syncingQuantity = false;
      }

      handleOptionChange(event) {
        if (this.syncingBulk) return;

        const target = event.target;
        if (target.closest('[data-boarding-variant="personalisation"]')) {
          this.syncState();
        }

        const selectOrInput = target.closest('select, input[type="radio"]');
        if (selectOrInput) {
          const val = selectOrInput.value || '';
          const match = val.match(/^(\d+)\s*(envelope|envelopes|piece|pieces|pcs|pack|packs)/i);
          if (match && match[1]) {
            const count = parseInt(match[1], 10);
            if (!Number.isNaN(count) && count > 0 && count !== this.cards.length) {
              this.setCardCount(count);
              return;
            }
          }
        }

        this.updateDynamicPriceAndTier();
      }

      syncCardsFromSelectedOptions() {
        const bulkSelectOrInput = this.productInfo?.querySelector(
          'select[name*="Bulk"], select[name*="Discount"], select[name*="discount"], select[name*="Multi-buy"], input[name*="Bulk"]:checked, input[name*="Discount"]:checked'
        );
        if (bulkSelectOrInput) {
          const val = bulkSelectOrInput.value || '';
          const match = val.match(/^(\d+)\s*(envelope|envelopes|piece|pieces|pcs|pack|packs)/i);
          if (match && match[1]) {
            const count = parseInt(match[1], 10);
            if (!Number.isNaN(count) && count > 0) {
              this.setCardCount(count);
              return;
            }
          }
        }
        this.syncCardsToQuantity();
      }

      setCardCount(targetQuantity) {
        targetQuantity = Math.max(1, Math.min(targetQuantity, this.maximumQuantity));

        while (this.cards.length < targetQuantity) {
          const nextCardIndex = this.cards.length + 1;
          this.restoreCachedCard(nextCardIndex) || this.createCard(nextCardIndex);
        }

        while (this.cards.length > targetQuantity) {
          const card = this.cards.at(-1);
          const cardIndex = parseInt(card?.dataset.cardIndex, 10);
          if (!card || Number.isNaN(cardIndex)) break;

          this.quantityCardCache.set(cardIndex, card);
          card.remove();
        }

        this.reindexCards();
        this.setQuantity(this.cards.length);
        this.syncBulkOption(this.cards.length);
        this.updateDynamicPriceAndTier();
      }

      syncState() {
        const personalisationVariant = this.productInfo?.querySelector(
          '[data-boarding-variant="personalisation"]'
        );
        if (!personalisationVariant) {
          this.hidden = false;
          this.setInputsDisabled(false);
          return;
        }
        const selectedValue = personalisationVariant.querySelector(
          'input[type="radio"]:checked'
        )?.value;
        const normalisedValue = (selectedValue || '').trim().toLocaleLowerCase();
        const withName = normalisedValue.includes('with name') || normalisedValue.includes('withname');

        this.hidden = false;
        this.querySelectorAll('.product__boarding-personalisation-field, [data-personalisation-field]').forEach((field) => {
          field.style.display = withName ? '' : 'none';
        });
        this.setInputsDisabled(!withName);
      }

      setInputsDisabled(disabled) {
        this.querySelectorAll('input:not([type="hidden"]), select, textarea').forEach((input) => {
          input.disabled = disabled;
          if (input.dataset.personalisationInput) {
            input.required = !disabled;
          }
        });
      }

      handleSwatchClick(event) {
        const swatch = event.target.closest('.envelope-colour-swatch');
        if (!swatch) return;
        event.preventDefault();

        const card = swatch.closest('[data-personalisation-card]');
        if (!card) return;

        const colourName = swatch.dataset.colourName;
        this.selectColourForCard(card, colourName);

        const cardIndex = card.dataset.cardIndex;
        const sameColourControl = this.cards[0]?.querySelector('[data-same-colour-for-all]');

        if (cardIndex === '1') {
          if (sameColourControl?.checked) {
            this.cards.slice(1).forEach((additionalCard) => {
              this.selectColourForCard(additionalCard, colourName);
            });
          }
        } else {
          if (sameColourControl?.checked) {
            sameColourControl.checked = false;
          }
        }
      }

      handleCheckboxChange(event) {
        const sameNameControl = event.target.closest('[data-same-name-for-all]');
        if (sameNameControl) {
          if (sameNameControl.checked) {
            const cardOneName = this.cards[0]?.querySelector('[data-personalisation-field="name"] [data-personalisation-input]')?.value || '';
            this.cards.slice(1).forEach((card) => {
              const input = card.querySelector('[data-personalisation-field="name"] [data-personalisation-input]');
              if (input) {
                input.value = cardOneName;
              }
            });
          }
          this.syncPlaceholders();
          return;
        }

        const sameColourControl = event.target.closest('[data-same-colour-for-all]');
        if (sameColourControl) {
          if (sameColourControl.checked) {
            const cardOneColour = this.cards[0]?.querySelector('.envelope-colour-swatch.is-active')?.dataset?.colourName
              || this.cards[0]?.querySelector('[data-envelope-colour-hidden-input]')?.value || 'Black';
            this.cards.slice(1).forEach((card) => {
              this.selectColourForCard(card, cardOneColour);
            });
          }
          return;
        }
      }

      selectColourForCard(card, colourName) {
        if (this.dataset.blackOnly === 'true') colourName = 'Black';
        const swatchesContainer = card.querySelector('.product__envelope-colour-swatches');
        const hiddenInput = card.querySelector('[data-envelope-colour-hidden-input]');
        const nameLabel = card.querySelector('[data-selected-colour-name]');

        if (hiddenInput) {
          hiddenInput.value = colourName;
          hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (nameLabel) {
          nameLabel.textContent = colourName;
        }

        if (swatchesContainer) {
          swatchesContainer.querySelectorAll('.envelope-colour-swatch').forEach((s) => {
            const isActive = s.dataset.colourName === colourName;
            s.classList.toggle('is-active', isActive);
            s.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        }
      }

      handleAddCard(event) {
        event?.preventDefault?.();
        if (this.cards.length >= this.maximumQuantity) return;

        const nextCardIndex = this.cards.length + 1;
        this.restoreCachedCard(nextCardIndex) || this.createCard(nextCardIndex);
        this.reindexCards();
        this.setQuantity(this.cards.length);
        this.syncBulkOption(this.cards.length);
        this.updateDynamicPriceAndTier();
        this.scrollToLastCard();
      }

      handleQuantityChange() {
        if (this.syncingQuantity) return;

        const qtyInput = this.quantityInput;
        if (!qtyInput) return;

        const requestedQuantity = parseInt(qtyInput.value, 10);
        const targetQuantity = Math.max(1, Math.min(Number.isNaN(requestedQuantity) ? 1 : requestedQuantity, this.maximumQuantity));

        if (targetQuantity === this.cards.length) return;

        this.setCardCount(targetQuantity);
        this.scrollToLastCard();
      }

      scrollToLastCard() {
        const lastCard = this.cards.at(-1);
        if (!lastCard) return;
        requestAnimationFrame(() => {
          const headerHeight = document.querySelector('.section-header')?.getBoundingClientRect().height || 0;
          const targetTop = lastCard.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
          window.scrollTo({
            top: Math.max(0, targetTop),
            behavior: 'smooth',
          });
        });
      }

      createCard(index) {
        const cardOne = this.cards[0];
        if (!cardOne || !this.cardsContainer) return null;

        const previousCard = this.cards[this.cards.length - 1] || cardOne;
        const previousColour = previousCard.querySelector('.envelope-colour-swatch.is-active')?.dataset?.colourName
          || previousCard.querySelector('[data-envelope-colour-hidden-input]')?.value;

        const card = cardOne.cloneNode(true);
        card.dataset.cardIndex = String(index);

        // Remove copy controls from cloned cards (only Envelope 1 should have them)
        card.querySelectorAll('[data-copy-name-wrapper], [data-copy-colour-wrapper]').forEach((el) => el.remove());

        const removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.className = 'product__boarding-personalisation-remove link underlined-link';
        removeButton.dataset.removePersonalisationCard = '';
        removeButton.textContent = this.removeCardLabel;
        removeButton.addEventListener('click', () => {
          const removedIndex = parseInt(card.dataset.cardIndex, 10);
          card.remove();
          this.shiftCachedCardsAfterRemoval(removedIndex);
          this.reindexCards();
          this.setQuantity(this.cards.length);
          this.syncBulkOption(this.cards.length);
          this.updateDynamicPriceAndTier();
        });

        const fields = card.querySelector('.product__boarding-personalisation-card-fields');
        card.insertBefore(removeButton, fields);

        const sameNameControl = cardOne.querySelector('[data-same-name-for-all]');
        const sameColourControl = cardOne.querySelector('[data-same-colour-for-all]');

        // Reset input value or copy from card 1 if sameNameControl is checked
        const nameInput = card.querySelector('[data-personalisation-field="name"] [data-personalisation-input]');
        if (nameInput) {
          nameInput.value = sameNameControl?.checked ? (cardOne.querySelector('[data-personalisation-field="name"] [data-personalisation-input]')?.value || '') : '';
          nameInput.dataset.defaultPlaceholder = cardOne.querySelector('[data-personalisation-field="name"] [data-personalisation-input]')?.dataset?.defaultPlaceholder || 'e.g., Amelia';
        }

        this.cardsContainer.append(card);
        this.reindexCards();

        const cardOneColour = cardOne.querySelector('.envelope-colour-swatch.is-active')?.dataset?.colourName
          || cardOne.querySelector('[data-envelope-colour-hidden-input]')?.value || 'Black';
        const assignedColour = sameColourControl?.checked ? cardOneColour : (previousColour || 'Black');
        if (assignedColour) {
          this.selectColourForCard(card, assignedColour);
        }

        return card;
      }

      restoreCachedCard(index) {
        const card = this.quantityCardCache.get(index);
        if (!card || !this.cardsContainer) return null;

        this.quantityCardCache.delete(index);
        this.cardsContainer.append(card);
        this.reindexCards();
        return card;
      }

      shiftCachedCardsAfterRemoval(removedIndex) {
        const shiftedCache = new Map();
        Array.from(this.quantityCardCache.entries())
          .sort(([a], [b]) => a - b)
          .forEach(([cachedIndex, cachedCard]) => {
            if (cachedIndex < removedIndex) {
              shiftedCache.set(cachedIndex, cachedCard);
              return;
            }

            if (cachedIndex === removedIndex) return;

            const nextIndex = cachedIndex - 1;
            cachedCard.dataset.cardIndex = String(nextIndex);
            shiftedCache.set(nextIndex, cachedCard);
          });

        this.quantityCardCache = shiftedCache;
      }

      reindexCards() {
        const cards = this.cards;
        const multipleCards = cards.length > 1;

        const cardOne = cards[0];
        if (cardOne) {
          const nameCopyWrapper = cardOne.querySelector('[data-copy-name-wrapper]');
          const colourCopyWrapper = cardOne.querySelector('[data-copy-colour-wrapper]');
          if (nameCopyWrapper) nameCopyWrapper.style.display = multipleCards ? 'inline-flex' : 'none';
          if (colourCopyWrapper) colourCopyWrapper.style.display = multipleCards ? 'inline-flex' : 'none';
          if (!multipleCards) {
            const sameNameInput = cardOne.querySelector('[data-same-name-for-all]');
            const sameColourInput = cardOne.querySelector('[data-same-colour-for-all]');
            if (sameNameInput) sameNameInput.checked = false;
            if (sameColourInput) sameColourInput.checked = false;
          }
        }

        cards.forEach((card, indexZeroBased) => {
          const index = indexZeroBased + 1;
          card.dataset.cardIndex = String(index);

          const nameEl = card.querySelector('[data-personalisation-card-name]');
          if (nameEl) {
            nameEl.textContent = multipleCards ? `${this.cardLabel} ${index}` : this.cardLabel;
          } else {
            const title = card.querySelector('[data-personalisation-card-title]');
            if (title) {
              title.textContent = multipleCards ? `${this.cardLabel} ${index}` : this.cardLabel;
            }
          }

          const removeButton = card.querySelector('[data-remove-personalisation-card]');
          if (removeButton) removeButton.setAttribute('aria-label', `${this.removeCardLabel}: ${this.cardLabel} ${index}`);

          card.querySelectorAll('[data-personalisation-field]').forEach((field) => {
            const input = field.querySelector('[data-personalisation-input]');
            const label = field.querySelector('.form__label');
            if (!input) return;

            const baseId = input.dataset.baseId;
            input.id = index === 1 ? baseId : `${baseId}-Card-${index}`;
            if (label && input.type !== 'hidden') label.setAttribute('for', input.id);

            const propertyLabel = input.dataset.propertyLabel;
            input.name = multipleCards
              ? `properties[${this.cardLabel} ${index}: ${propertyLabel}]`
              : `properties[${propertyLabel}]`;
          });
        });

        if (this.addCardButton) this.addCardButton.disabled = cards.length >= this.maximumQuantity;
        this.updateDynamicPriceAndTier();
        this.syncPlaceholders();
      }

      syncPlaceholders() {
        const nameInputs = Array.from(this.querySelectorAll('[data-personalisation-field="name"] [data-personalisation-input]'));
        if (nameInputs.length === 0) return;
        const hasAnyValue = nameInputs.some((input) => (input.value || '').trim().length > 0);
        const defaultPlaceholder = nameInputs[0]?.dataset?.defaultPlaceholder || 'e.g., Amelia';

        nameInputs.forEach((input) => {
          input.placeholder = hasAnyValue ? '' : (input.dataset.defaultPlaceholder || defaultPlaceholder);
        });
      }

      syncCardsToQuantity() {
        const qtyInput = this.quantityInput;
        if (!qtyInput) return;

        const requestedQuantity = parseInt(qtyInput.value, 10);
        const targetQuantity = Math.max(1, Math.min(Number.isNaN(requestedQuantity) ? 1 : requestedQuantity, this.maximumQuantity));

        const isIncreasing = targetQuantity > this.cards.length;

        let lastAddedCard = null;
        while (this.cards.length < targetQuantity) {
          const nextCardIndex = this.cards.length + 1;
          const card = this.restoreCachedCard(nextCardIndex) || this.createCard(nextCardIndex);
          if (card) {
            lastAddedCard = card;
          }
        }

        while (this.cards.length > targetQuantity) {
          const card = this.cards.at(-1);
          const cardIndex = parseInt(card?.dataset.cardIndex, 10);
          if (!card || Number.isNaN(cardIndex)) break;

          this.quantityCardCache.set(cardIndex, card);
          card.remove();
        }

        this.reindexCards();
        this.setQuantity(this.cards.length);
        this.syncBulkOption(this.cards.length);
        this.updateDynamicPriceAndTier();

        if (isIncreasing && lastAddedCard) {
          this.scrollToLastCard();
        }
      }

      validate() {
        for (let i = 0; i < this.cards.length; i++) {
          const card = this.cards[i];
          const nameInput = card.querySelector('[data-personalisation-field="name"] [data-personalisation-input]');
          if (nameInput && nameInput.required && !nameInput.disabled && !nameInput.value.trim()) {
            nameInput.focus();
            return `Please enter a name for ${this.cardLabel} ${i + 1}`;
          }
        }
        return null;
      }

      getCartItems() {
        const count = Math.max(1, this.cards.length);
        const tiers = this.getAvailableTiers();
        const selectedTiers = this.calculateTiers(count, tiers);

        const cardData = this.cards.map((card, idx) => {
          const nameVal = card.querySelector('[data-personalisation-field="name"] [data-personalisation-input]')?.value?.trim() || '';
          const colourVal = this.dataset.blackOnly === 'true' ? 'Black' : (card.querySelector('[data-envelope-colour-hidden-input]')?.value || 'Black');
          return {
            index: idx + 1,
            name: nameVal,
            colour: colourVal
          };
        });

        const items = [];
        let cardOffset = 0;

        for (const tier of selectedTiers) {
          const tierCards = cardData.slice(cardOffset, cardOffset + tier.size);
          cardOffset += tier.size;

          const properties = {};
          if (this.cards.length === 1) {
            if (tierCards[0]?.name) properties['Name'] = tierCards[0].name;
            if (tierCards[0]?.colour) properties['Colour'] = tierCards[0].colour;
          } else {
            tierCards.forEach(c => {
              if (c.name) properties[`${this.cardLabel} ${c.index}: Name`] = c.name;
              if (c.colour) properties[`${this.cardLabel} ${c.index}: Colour`] = c.colour;
            });
          }

          items.push({
            id: String(tier.variantId),
            quantity: 1,
            properties
          });
        }

        return items;
      }

      cleanCartProperties(properties) {
        return properties;
      }

      restoreCartLineEdit(line) {
        if (!this.quantityInput) return;

        this.syncingQuantity = true;
        this.quantityInput.value = String(line.quantity);
        this.syncingQuantity = false;
        this.syncCardsToQuantity();

        const properties = line.properties || {};
        this.cards.forEach((card, index) => {
          const cardIndex = index + 1;
          const multipleCards = this.cards.length > 1;

          const nameKey = multipleCards ? `${this.cardLabel} ${cardIndex}: Name` : 'Name';
          const nameVal = properties[nameKey] || properties['Name'] || '';
          const nameInput = card.querySelector('[data-personalisation-field="name"] [data-personalisation-input]');
          if (nameInput) nameInput.value = nameVal;

          const colourKey = multipleCards ? `${this.cardLabel} ${cardIndex}: Colour` : 'Colour';
          const altColourKey = multipleCards ? `${this.cardLabel} ${cardIndex}: Envelope Colour` : 'Envelope Colour';
          const colourVal = properties[colourKey] || properties[altColourKey] || properties['Colour'] || properties['Envelope Colour'] || '';
          if (colourVal) {
            this.selectColourForCard(card, colourVal);
          }
        });
      }
    }

    customElements.define('envelope-name-input', EnvelopeNameInput);
  }

  if (!customElements.get('boarding-personalisation')) {
    class BoardingPersonalisation extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.productInfo = this.closest('product-info') || document.querySelector('product-info');
        this.cardsContainer = this.querySelector('[data-personalisation-cards]');
        this.addCardButton = this.querySelector('[data-add-personalisation-card]');
        this.cardLabel = this.dataset.cardLabel || 'Card';
        this.removeCardLabel = this.dataset.removeCardLabel || 'Remove card';
        this.sameAsCardOneLabel = this.dataset.sameAsCardOneLabel || 'Same as Card 1';
        this.quantityCardCache = new Map();
        this.syncingQuantity = false;
        this.handleAddCard = this.handleAddCard.bind(this);
        this.handlePersonalisationChange = this.handlePersonalisationChange.bind(this);
        this.handleCardClick = this.handleCardClick.bind(this);
        this.handlePersonalisationInput = this.handlePersonalisationInput.bind(this);
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);

        this.cardsContainer?.addEventListener('click', this.handleCardClick);
        this.addCardButton?.addEventListener('click', this.handleAddCard);
        this.addEventListener('change', this.handlePersonalisationChange);
        this.addEventListener('input', this.handlePersonalisationInput);

        this.handleQuantityEvent = (event) => {
          const target = event?.target;
          if (target && (target.classList?.contains('quantity__input') || (target.matches && target.matches('.quantity__input')) || target.name === 'quantity')) {
            this.handleQuantityChange();
          }
        };
        (this.productInfo || document).addEventListener('change', this.handleQuantityEvent);
        (this.productInfo || document).addEventListener('input', this.handleQuantityEvent);

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange);
        this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
          if (this.quantityInput && !this.syncingQuantity && this.cards.length > 0) {
            this.syncingQuantity = true;
            this.quantityInput.value = String(this.cards.length);
            this.quantityInput.setAttribute('value', String(this.cards.length));
            this.syncingQuantity = false;
          }
        });
        this.syncCardsToQuantity();
        this.cards.forEach((card) => {
          const currentPers = card.querySelector('[data-envelope-personalisation-hidden-input]')?.value
            || card.querySelector('.boarding-personalisation-option')?.dataset.personalisationName;
          this.selectEnvelopePersonalisationForCard(card, currentPers);
        });

        customElements.whenDefined('product-form').then(() => {
          const productForm = this.productInfo?.querySelector('product-form');
          productForm?.editLinePromise?.then((line) => {
            if (!line || !this.isConnected) return;
            this.restoreCartLineEdit(line);
            const firstCard = this.cards[0];
            if (firstCard) {
              this.expandCard(firstCard);
              this.scrollToCard(firstCard);
            }
          });
        });
      }

      disconnectedCallback() {
        this.cardsContainer?.removeEventListener('click', this.handleCardClick);
        this.addCardButton?.removeEventListener('click', this.handleAddCard);
        this.removeEventListener('change', this.handlePersonalisationChange);
        this.removeEventListener('input', this.handlePersonalisationInput);
        if (this.handleQuantityEvent) {
          (this.productInfo || document).removeEventListener('change', this.handleQuantityEvent);
          (this.productInfo || document).removeEventListener('input', this.handleQuantityEvent);
        }
        this.variantChangeUnsubscriber?.();
        this.quantityUpdateUnsubscriber?.();
      }

      get quantityInput() {
        return this.productInfo?.querySelector('.quantity__input') || document.querySelector('.quantity__input');
      }

      get cards() {
        return Array.from(this.cardsContainer?.querySelectorAll('[data-personalisation-card]') || []);
      }

      get maximumQuantity() {
        const maximum = parseInt(this.quantityInput?.max, 10);
        return Number.isNaN(maximum) ? Infinity : maximum;
      }

      getCardSelections(card) {
        if (!card) return {};

        return {
          colour:
            card.querySelector('.boarding-colour-swatch.is-active')?.dataset.colourName ||
            card.querySelector('[data-card-colour-hidden-input]')?.value,
          envelope:
            card.querySelector('.product__boarding-card-section--envelope .boarding-envelope-option.is-active')
              ?.dataset.envelopeName ||
            card.querySelector('[data-envelope-hidden-input]')?.value,
          personalisation:
            card.querySelector('.boarding-personalisation-option.is-active')?.dataset.personalisationName ||
            card.querySelector('[data-envelope-personalisation-hidden-input]')?.value,
        };
      }

      updateCardPreview(card) {
        if (!card) return;
        const { colour, envelope, personalisation } = this.getCardSelections(card);
        const mediaGallery = document.querySelector('media-gallery') || this.productInfo?.querySelector('media-gallery');
        if (mediaGallery && typeof mediaGallery.updateLayeredPreview === 'function') {
          mediaGallery.updateLayeredPreview({ colour, envelope, personalisation });
        }
      }

      handleCardClick(event) {
        const clickedCard = event.target.closest('[data-personalisation-card]');
        if (clickedCard) {
          if (clickedCard.classList.contains('is-collapsed') || event.target.closest('[data-personalisation-card-title]')) {
            this.toggleCard(clickedCard);
            if (clickedCard.classList.contains('is-collapsed')) return;
          }
        }

        const colourSwatch = event.target.closest('.boarding-colour-swatch');
        if (colourSwatch) {
          const card = colourSwatch.closest('[data-personalisation-card]');
          const colourName = colourSwatch.dataset.colourName;
          if (card && colourName) {
            this.selectColourForCard(card, colourName);
          }
          return;
        }

        const persOption = event.target.closest('.boarding-personalisation-option');
        if (persOption) {
          const card = persOption.closest('[data-personalisation-card]');
          const persName = persOption.dataset.personalisationName;
          if (card && persName) {
            this.selectEnvelopePersonalisationForCard(card, persName);
          }
          return;
        }

        const envOption = event.target.closest('.boarding-envelope-option');
        if (envOption) {
          const card = envOption.closest('[data-personalisation-card]');
          const envName = envOption.dataset.envelopeName;
          if (card && envName) {
            this.selectEnvelopeForCard(card, envName);
          }
          return;
        }
      }

      expandCard(card) {
        if (!card) return;
        this.cards.forEach((c) => {
          if (c !== card) {
            c.classList.remove('is-expanded');
            c.classList.add('is-collapsed');
          }
        });
        card.classList.remove('is-collapsed');
        card.classList.add('is-expanded');
        this.updateCardPreview(card);
      }

      collapseCard(card) {
        if (!card) return;
        card.classList.remove('is-expanded');
        card.classList.add('is-collapsed');
      }

      scrollToCard(card) {
        if (!card) return;
        requestAnimationFrame(() => {
          const header = document.querySelector('sticky-header') || document.querySelector('.section-header') || document.querySelector('.header-wrapper') || document.querySelector('header');
          const headerHeight = header ? header.offsetHeight : 0;

          const titleEl = card.querySelector('.product__boarding-personalisation-card-title') ||
                          card.querySelector('[data-personalisation-card-title]') ||
                          card;
          const isMobile = window.matchMedia('(max-width: 749px)').matches || window.innerWidth < 750;
          const offsetBelowHeader = isMobile ? 24 : 31;
          const targetTop = titleEl.getBoundingClientRect().top + window.pageYOffset - headerHeight - offsetBelowHeader;

          window.scrollTo({
            top: Math.max(0, targetTop),
            behavior: 'smooth'
          });
        });
      }

      toggleCard(card) {
        if (!card) return;
        if (card.classList.contains('is-collapsed')) {
          this.expandCard(card);
          this.scrollToCard(card);
        } else if (this.cards.length > 1) {
          this.collapseCard(card);
        }
      }

      findVariantOptionInput(optionKind, value) {
        if (!value) return null;

        const normalise = (inputValue) => (inputValue || '').trim().toLocaleLowerCase();
        const expectedValue = normalise(value);
        const inputs = Array.from(
          this.productInfo?.querySelectorAll('variant-selects input[type="radio"]') || []
        );

        return inputs.find((input) => {
          if (normalise(input.value) !== expectedValue) return false;

          const optionName = normalise(input.dataset.optionName || input.name);
          if (optionKind === 'colour') {
            return optionName.includes('card colour') || optionName.includes('card color');
          }
          if (optionKind === 'personalisation') {
            return optionName.includes('personalisation') || optionName.includes('personalization');
          }
          if (optionKind === 'envelope') {
            const isPersonalisation = optionName.includes('personalisation') || optionName.includes('personalization');
            return optionName.includes('envelope') && !isPersonalisation;
          }
          return false;
        }) || null;
      }

      syncVariantSelectionFromCard(card, changedOption) {
        if (!card) return;

        const selections = this.getCardSelections(card);
        const cardHiddenInput = card.querySelector('[data-card-colour-hidden-input]');
        const envelopeHiddenInput = card.querySelector('[data-envelope-hidden-input]');
        const personalisationHiddenInput = card.querySelector('[data-envelope-personalisation-hidden-input]');
        if (cardHiddenInput && selections.colour) cardHiddenInput.value = selections.colour;
        if (envelopeHiddenInput && selections.envelope) envelopeHiddenInput.value = selections.envelope;
        if (personalisationHiddenInput && selections.personalisation) {
          personalisationHiddenInput.value = selections.personalisation;
        }
        const inputs = Object.fromEntries(
          Object.entries(selections).map(([kind, value]) => [kind, this.findVariantOptionInput(kind, value)])
        );
        const changedInput = inputs[changedOption];
        const shouldDispatch = Boolean(changedInput && !changedInput.checked);

        Object.values(inputs).forEach((input) => {
          if (input) input.checked = true;
        });

        if (shouldDispatch) {
          changedInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      selectColourForCard(card, colourName) {
        if (!card || !colourName) return;
        const swatches = card.querySelectorAll('.boarding-colour-swatch');
        swatches.forEach((s) => {
          const isActive = s.dataset.colourName?.toLowerCase() === colourName.toLowerCase();
          s.classList.toggle('is-active', isActive);
          s.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        const hiddenInput = card.querySelector('[data-card-colour-hidden-input]');
        if (hiddenInput) hiddenInput.value = colourName;
        const labelName = card.querySelector('[data-selected-card-colour-name]');
        if (labelName) labelName.textContent = colourName;

        this.updateCardPreview(card);
        this.syncVariantSelectionFromCard(card, 'colour');
      }

      selectEnvelopeForCard(card, envelopeName) {
        if (!card || !envelopeName) return;
        const options = card.querySelectorAll('.product__boarding-card-section--envelope .boarding-envelope-option');
        options.forEach((opt) => {
          const isActive = opt.dataset.envelopeName?.toLowerCase() === envelopeName.toLowerCase();
          opt.classList.toggle('is-active', isActive);
          opt.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        const hiddenInput = card.querySelector('[data-envelope-hidden-input]');
        if (hiddenInput) hiddenInput.value = envelopeName;
        const labelName = card.querySelector('[data-selected-envelope-name]');
        if (labelName) labelName.textContent = envelopeName;

        const isNone = envelopeName.toLowerCase().includes('no envelope') || envelopeName.toLowerCase() === 'none';
        const persSection = card.querySelector('[data-personalisation-field="envelope-personalisation"]');
        const persDivider = persSection?.nextElementSibling;
        if (isNone) {
          if (persSection) persSection.style.display = 'none';
          if (persDivider && persDivider.classList.contains('product__boarding-card-divider')) persDivider.style.display = 'none';
          // Preserve the current name choice so the envelope change remains the single dispatched variant update.
        } else {
          if (persSection) persSection.style.display = '';
          if (persDivider && persDivider.classList.contains('product__boarding-card-divider')) persDivider.style.display = '';
        }

        this.updateCardPreview(card);
        this.syncVariantSelectionFromCard(card, 'envelope');
      }

      selectEnvelopePersonalisationForCard(card, persName) {
        if (!card || !persName) return;
        const options = card.querySelectorAll('.boarding-personalisation-option');
        options.forEach((opt) => {
          const isActive = opt.dataset.personalisationName?.toLowerCase() === persName.toLowerCase();
          opt.classList.toggle('is-active', isActive);
          opt.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        const hiddenInput = card.querySelector('[data-envelope-personalisation-hidden-input]');
        if (hiddenInput) hiddenInput.value = persName;
        const labelName = card.querySelector('[data-selected-envelope-personalisation-name]');
        if (labelName) labelName.textContent = persName;

        const isEnvelopeOnly = this.closest('.product--premium-envelope') || this.dataset.template === 'premium-envelope' || !card.querySelector('.product__boarding-card-section--colour');
        if (isEnvelopeOnly) {
          const isWithName = persName.toLowerCase().includes('with name') || persName.toLowerCase().includes('withname');
          const detailsSection = card.querySelector('.product__boarding-card-section--details');
          const nameField = card.querySelector('[data-personalisation-field="full-name"]');
          const targetField = detailsSection || nameField;
          if (targetField) {
            if (isWithName) {
              targetField.style.display = '';
              const inp = targetField.querySelector('input');
              if (inp) {
                inp.disabled = false;
              }
            } else {
              targetField.style.display = 'none';
              const inp = targetField.querySelector('input');
              if (inp) {
                inp.disabled = true;
                inp.value = '';
              }
            }
          }
        }

        this.updateCardPreview(card);
        this.syncVariantSelectionFromCard(card, 'personalisation');
      }

      restoreCartLineEdit(line) {
        if (!this.quantityInput) return;

        this.syncingQuantity = true;
        this.quantityInput.value = String(line.quantity);
        this.syncingQuantity = false;
        this.syncCardsToQuantity();

        const properties = line.properties || {};
        const normalise = (value) => (value || '').trim().toLowerCase();
        const variantOptions = new Map(
          (line.options_with_values || []).map((option) => [normalise(option.name), option.value])
        );
        const getVariantOption = (...names) => {
          for (const name of names) {
            const value = variantOptions.get(normalise(name));
            if (value) return value;
          }
          return '';
        };

        this.cards.forEach((card, index) => {
          const cardIndex = index + 1;
          const multipleCards = this.cards.length > 1;

          card.querySelectorAll('[data-personalisation-input]').forEach((input) => {
            const propertyMatch = input.name.match(/^properties\[(.+)\]$/);
            if (!propertyMatch) return;
            const propKey = propertyMatch[1];
            const cleanKey = propKey.replace(/^(Card|Envelope)\s+\d+:\s*/i, '');
            input.value = properties[propKey] ?? properties[cleanKey] ?? '';
          });

          const colourKey = multipleCards ? `${this.cardLabel} ${cardIndex}: Card Colour` : 'Card Colour';
          const colourVal =
            getVariantOption('Card Colour', 'Card Color') || properties[colourKey] || properties['Card Colour'] || '';
          if (colourVal) this.selectColourForCard(card, colourVal);

          const envKey = multipleCards ? `${this.cardLabel} ${cardIndex}: Envelope` : 'Envelope';
          const envVal = getVariantOption('Envelope', 'Choose Your Envelope') || properties[envKey] || properties['Envelope'] || properties['Choose Your Envelope'] || '';
          if (envVal) this.selectEnvelopeForCard(card, envVal);

          const persKey = multipleCards ? `${this.cardLabel} ${cardIndex}: Envelope Personalisation` : 'Envelope Personalisation';
          const persVal =
            getVariantOption('Envelope Personalisation', 'Envelope Personalization', 'Personalisation', 'Personalization') ||
            properties[persKey] ||
            properties['Envelope Personalisation'] ||
            properties['Personalisation'] ||
            '';
          if (persVal) this.selectEnvelopePersonalisationForCard(card, persVal);
        });

        if (this.details) this.details.open = true;
      }

      handleVariantChange({ data }) {
        if (!this.quantityInput || (data?.sectionId && data.sectionId !== this.productInfo?.dataset.section)) return;

        this.syncingQuantity = true;
        this.quantityInput.value = String(this.cards.length);
        this.quantityInput.setAttribute('value', String(this.cards.length));
        this.syncingQuantity = false;
      }

      handleAddCard(event) {
        event.preventDefault();
        if (this.cards.length >= this.maximumQuantity) return;

        this.cards.forEach((c) => this.collapseCard(c));
        const nextCardIndex = this.cards.length + 1;
        const newCard = this.restoreCachedCard(nextCardIndex) || this.createCard(nextCardIndex);
        if (newCard) {
          this.expandCard(newCard);
          this.scrollToCard(newCard);
        }
        this.setQuantity(this.cards.length);
      }

      handleQuantityChange() {
        if (this.syncingQuantity) return;

        const previousCardCount = this.cards.length;
        this.syncCardsToQuantity();
        if (this.cards.length === previousCardCount) return;
      }

      handlePersonalisationChange(event) {
        const copyControl = event.target.closest('[data-copy-from-card-one]');
        if (!copyControl) return;

        const field = copyControl.closest('[data-personalisation-field]');
        const input = field?.querySelector('[data-personalisation-input]');
        if (!input) return;

        if (copyControl.checked) {
          this.copyCardOneValue(input);
          input.readOnly = false;
          field.classList.remove('is-copying-card-one');
        } else {
          input.value = '';
          input.readOnly = false;
          field.classList.remove('is-copying-card-one');
        }
      }

      handlePersonalisationInput(event) {
        const input = event.target.closest('[data-personalisation-input]');
        const card = input?.closest('[data-personalisation-card]');
        if (!input || !card) return;

        if (card.dataset.cardIndex !== '1') {
          const field = input.closest('[data-personalisation-field]');
          const copyControl = field?.querySelector('[data-copy-from-card-one]');
          if (copyControl?.checked) {
            copyControl.checked = false;
            input.readOnly = false;
            field.classList.remove('is-copying-card-one');
          }
          return;
        }

        this.cards.slice(1).forEach((additionalCard) => {
          const matchingField = additionalCard.querySelector(
            `[data-personalisation-field="${input.dataset.fieldKey}"]`
          );
          const copyControl = matchingField?.querySelector('[data-copy-from-card-one]');
          const matchingInput = matchingField?.querySelector('[data-personalisation-input]');
          if (copyControl?.checked && matchingInput) matchingInput.value = input.value;
        });
      }

      copyCardOneValue(input) {
        const cardOneInput = this.cards[0]?.querySelector(
          `[data-personalisation-input][data-field-key="${input.dataset.fieldKey}"]`
        );
        if (cardOneInput) input.value = cardOneInput.value;
      }

      createCard(index) {
        const cardOne = this.cards[0];
        if (!cardOne || !this.cardsContainer) return null;

        const previousCard = this.cards[this.cards.length - 1] || cardOne;
        const prevCardColour = previousCard.querySelector('[data-card-colour-hidden-input]')?.value;
        const prevEnvelope = previousCard.querySelector('[data-envelope-hidden-input]')?.value;
        const prevEnvelopePers = previousCard.querySelector('[data-envelope-personalisation-hidden-input]')?.value;

        const card = cardOne.cloneNode(true);
        card.dataset.cardIndex = String(index);

        card.querySelectorAll('[data-remove-personalisation-card]').forEach((b) => b.remove());

        const removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.className = 'product__boarding-personalisation-remove link underlined-link';
        removeButton.dataset.removePersonalisationCard = '';
        removeButton.textContent = this.removeCardLabel;
        removeButton.addEventListener('click', (e) => {
          e.stopPropagation();
          const removedIndex = parseInt(card.dataset.cardIndex, 10);
          const wasExpanded = !card.classList.contains('is-collapsed');
          card.remove();
          this.shiftCachedCardsAfterRemoval(removedIndex);
          this.reindexCards();
          this.setQuantity(this.cards.length);
          if (wasExpanded && this.cards.length > 0) {
            this.expandCard(this.cards.at(-1));
          }
        });

        // Append remove button to the bottom of the card
        card.append(removeButton);

        card.querySelectorAll('[data-personalisation-field]').forEach((field) => {
          const key = field.dataset.personalisationField;
          if (key === 'card-colour' || key === 'envelope' || key === 'envelope-personalisation') return;

          const input = field.querySelector('[data-personalisation-input]');
          if (!input) return;

          input.value = '';
          input.readOnly = false;

          field.querySelectorAll('.product__boarding-personalisation-copy').forEach((l) => l.remove());

          const copyLabel = document.createElement('label');
          copyLabel.className = 'product__boarding-personalisation-copy';

          const copyControl = document.createElement('input');
          copyControl.type = 'checkbox';
          copyControl.dataset.copyFromCardOne = '';

          const copyText = document.createElement('span');
          copyText.textContent = this.sameAsCardOneLabel;

          copyLabel.append(copyControl, copyText);
          field.append(copyLabel);
        });

        this.cardsContainer.append(card);
        if (prevCardColour) {
          this.selectColourForCard(card, prevCardColour);
        }
        if (prevEnvelope) {
          this.selectEnvelopeForCard(card, prevEnvelope);
        }
        if (prevEnvelopePers) {
          this.selectEnvelopePersonalisationForCard(card, prevEnvelopePers);
        }
        this.reindexCards();
        return card;
      }

      restoreCachedCard(index) {
        const card = this.quantityCardCache.get(index);
        if (!card || !this.cardsContainer) return null;

        this.quantityCardCache.delete(index);
        this.cardsContainer.append(card);

        card.querySelectorAll('[data-personalisation-field]').forEach((field) => {
          const copyControl = field.querySelector('[data-copy-from-card-one]');
          const input = field.querySelector('[data-personalisation-input]');
          if (copyControl?.checked && input) this.copyCardOneValue(input);
        });

        this.reindexCards();
        return card;
      }

      shiftCachedCardsAfterRemoval(removedIndex) {
        if (Number.isNaN(removedIndex) || this.quantityCardCache.size === 0) return;

        const shiftedCards = new Map();
        this.quantityCardCache.forEach((cachedCard, index) => {
          shiftedCards.set(index > removedIndex ? index - 1 : index, cachedCard);
        });
        this.quantityCardCache = shiftedCards;
      }

      reindexCards() {
        const cards = this.cards;
        const multipleCards = cards.length > 1;

        cards.forEach((card, cardIndex) => {
          const index = cardIndex + 1;
          card.dataset.cardIndex = String(index);

          const nameEl = card.querySelector('[data-personalisation-card-name]');
          if (nameEl) {
            nameEl.textContent = multipleCards ? `${this.cardLabel} ${index}` : this.cardLabel;
          } else {
            const title = card.querySelector('[data-personalisation-card-title]');
            if (title) title.textContent = multipleCards ? `${this.cardLabel} ${index}` : this.cardLabel;
          }

          const removeButton = card.querySelector('[data-remove-personalisation-card]');
          if (removeButton) removeButton.setAttribute('aria-label', `${this.removeCardLabel}: ${this.cardLabel} ${index}`);

          card.querySelectorAll('[data-personalisation-field]').forEach((field) => {
            const input = field.querySelector('[data-personalisation-input]');
            const label = field.querySelector('.form__label');
            if (!input) return;

            const baseId = input.dataset.baseId;
            input.id = index === 1 ? baseId : `${baseId}-Card-${index}`;
            if (label) label.setAttribute('for', input.id);

            const propertyLabel = input.dataset.propertyLabel;
            input.name = multipleCards
              ? `properties[${this.cardLabel} ${index}: ${propertyLabel}]`
              : `properties[${propertyLabel}]`;

            const copyControl = field.querySelector('[data-copy-from-card-one]');
            if (copyControl) copyControl.setAttribute('aria-controls', input.id);
          });
        });

        if (cards.length === 1 && cards[0].classList.contains('is-collapsed')) {
          this.expandCard(cards[0]);
        }

        if (this.addCardButton) this.addCardButton.disabled = cards.length >= this.maximumQuantity;
      }

      syncCardsToQuantity() {
        const qtyInput = this.quantityInput;
        if (!qtyInput) return;

        const requestedQuantity = parseInt(qtyInput.value, 10);
        const targetQuantity = Math.max(1, Math.min(Number.isNaN(requestedQuantity) ? 1 : requestedQuantity, this.maximumQuantity));

        const isIncreasing = targetQuantity > this.cards.length;

        if (this.cards.length < targetQuantity) {
          this.cards.forEach((c) => this.collapseCard(c));
        }

        let lastAddedCard = null;
        while (this.cards.length < targetQuantity) {
          const nextCardIndex = this.cards.length + 1;
          const card = this.restoreCachedCard(nextCardIndex) || this.createCard(nextCardIndex);
          if (card) {
            this.expandCard(card);
            lastAddedCard = card;
          }
        }

        while (this.cards.length > targetQuantity) {
          const card = this.cards.at(-1);
          const cardIndex = parseInt(card?.dataset.cardIndex, 10);
          if (!card || Number.isNaN(cardIndex)) break;

          this.quantityCardCache.set(cardIndex, card);
          card.remove();
        }

        this.reindexCards();

        if (isIncreasing && lastAddedCard) {
          this.expandCard(lastAddedCard);
          this.scrollToCard(lastAddedCard);
        } else if (this.cards.length > 0 && !this.cards.some((c) => !c.classList.contains('is-collapsed'))) {
          this.expandCard(this.cards.at(-1));
        }
      }

      setQuantity(quantity) {
        const input = this.quantityInput;
        if (!input) return;

        this.syncingQuantity = true;
        input.value = String(quantity);
        input.setAttribute('value', String(quantity));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
        this.syncingQuantity = false;
      }

      cleanCartProperties(properties = {}) {
        const variantPropertyNames = new Set([
          'card colour',
          'card color',
          'envelope',
          'envelope personalisation',
          'envelope personalization',
        ]);

        return Object.fromEntries(
          Object.entries(properties).filter(([name]) => {
            const cleanName = name.replace(/^(Card|Envelope)\s+\d+:\s*/i, '').trim().toLowerCase();
            return !variantPropertyNames.has(cleanName);
          })
        );
      }

      validate() {
        const cards = this.cards;
        const isEnvelopeOnly = this.closest('.product--premium-envelope') || this.dataset.template === 'premium-envelope' || !this.querySelector('.product__boarding-card-section--colour');

        for (let i = 0; i < cards.length; i++) {
          const card = cards[i];
          const nameInput = card.querySelector('[data-personalisation-field="full-name"] [data-personalisation-input]');

          if (isEnvelopeOnly) {
            const pers = card.querySelector('[data-envelope-personalisation-hidden-input]')?.value
              || card.querySelector('.boarding-personalisation-option')?.dataset.personalisationName
              || '';
            const isWithName = pers.toLowerCase().includes('with name') || pers.toLowerCase().includes('withname');
            if (isWithName && nameInput && !nameInput.value.trim()) {
              this.expandCard(card);
              this.scrollToCard(card);
              nameInput.focus();
              return `Please enter a name for ${cards.length > 1 ? (this.cardLabel + ' ' + (i + 1)) : this.cardLabel}.`;
            }
          } else {
            const occasionInput = card.querySelector('[data-personalisation-field="date"] [data-personalisation-input]');
            const surpriseInput = card.querySelector('[data-personalisation-field="destination"] [data-personalisation-input]');
            const hasOccasionField = occasionInput?.dataset.propertyLabel?.trim().toLowerCase().includes('occasion');

            if (hasOccasionField && !occasionInput.value.trim()) {
              this.expandCard(card);
              this.scrollToCard(card);
              occasionInput.focus();
              return `Please enter the occasion for ${cards.length > 1 ? (this.cardLabel + ' ' + (i + 1)) : this.cardLabel}.`;
            }

            if (surpriseInput && !surpriseInput.value.trim()) {
              this.expandCard(card);
              this.scrollToCard(card);
              surpriseInput.focus();
              return `Please enter the surprise under the scratch-off for ${cards.length > 1 ? (this.cardLabel + ' ' + (i + 1)) : this.cardLabel}.`;
            }
          }
        }
        return null;
      }

      getCartItems() {
        const variantsScript = this.productInfo?.querySelector('[data-product-variants]') || document.querySelector('[data-product-variants]');
        let variants = [];
        try {
          if (variantsScript) variants = JSON.parse(variantsScript.textContent);
        } catch (e) {}

        const normalise = (v) => (v || '').trim().toLowerCase();

        return this.cards.map((card) => {
          const colour = card.querySelector('[data-card-colour-hidden-input]')?.value || '';
          const envelope = card.querySelector('[data-envelope-hidden-input]')?.value || '';
          const personalisation = card.querySelector('[data-envelope-personalisation-hidden-input]')?.value || '';

          const selectedOptions = [colour, envelope, personalisation].filter(Boolean).map(normalise);
          let match = variants.find((variant) => {
            const variantOptions = (variant.options || [variant.option1, variant.option2, variant.option3]).map(normalise);
            return selectedOptions.every((selectedOption, index) => variantOptions[index] === selectedOption);
          });

          if (!match) {
            match = variants.find((variant) => {
              const variantOptions = (variant.options || [variant.option1, variant.option2, variant.option3])
                .filter(Boolean)
                .map(normalise);
              return selectedOptions.length === variantOptions.length && selectedOptions.every((opt, idx) => variantOptions[idx] === opt);
            });
          }

          if (!match) {
            match = variants.find((variant) => {
              const variantOptions = (variant.options || [variant.option1, variant.option2, variant.option3])
                .filter(Boolean)
                .map(normalise);
              return selectedOptions.every((opt) => variantOptions.includes(opt));
            }) || (variants.length === 1 ? variants[0] : null);
          }

          if (!match) {
            const mainVariantId = this.productInfo?.querySelector('input[name="id"]')?.value;
            if (mainVariantId) {
              match = variants.find((v) => String(v.id) === String(mainVariantId)) || { id: mainVariantId };
            }
          }

          if (!match) {
            throw new Error(this.dataset.variantUnavailableMessage || 'Unavailable');
          }

          const properties = {};

          card.querySelectorAll('[data-personalisation-input]').forEach((input) => {
            if (input.disabled) return;
            const propLabel = input.dataset.propertyLabel || input.dataset.fieldKey || input.name.replace(/^properties\[(.+)\]$/, '$1');
            const cleanLabel = propLabel.replace(/^(Card|Envelope)\s+\d+:\s*/i, '');
            if (input.value && input.value.trim() && !cleanLabel.startsWith('_')) {
              properties[cleanLabel] = input.value.trim();
            }
          });

          return {
            id: String(match.id),
            quantity: 1,
            properties,
          };
        });
      }
    }

    customElements.define('boarding-personalisation', BoardingPersonalisation);
  }

  } catch(e) { console.error(e); }
})();
})();
